import { Form } from '@moneyforward/ap-frontend-components';

import { OptionCode } from '@/features/transaction_items/Detail/components/Drawer/TransactionDetailOptionDrawer/Form/OptionCode';
import { OptionLabel } from '@/features/transaction_items/Detail/components/Drawer/TransactionDetailOptionDrawer/Form/OptionLabel';
import { OptionPriority } from '@/features/transaction_items/Detail/components/Drawer/TransactionDetailOptionDrawer/Form/OptionPriority';
import { OptionVisible } from '@/features/transaction_items/Detail/components/Drawer/TransactionDetailOptionDrawer/Form/OptionVisible';
import { TransactionDetailOptionFormType } from '@/features/transaction_items/Detail/type';
import classNames from 'classnames';
import { FC, memo, ReactNode } from 'react';
import { UseFormReturn } from 'react-hook-form';
import styles from './TransactionDetailOptionForm.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  methods: UseFormReturn<TransactionDetailOptionFormType>;
  onSubmit: (data: TransactionDetailOptionFormType) => void;
  notificationErrorVisible: boolean;
  notificationErrorContextHolder: ReactNode;
};

export const TransactionDetailOptionForm: FC<Props> = memo(
  ({
    methods,
    onSubmit,
    notificationErrorVisible,
    notificationErrorContextHolder,
  }) => {
    const { control, clearErrors } = methods;

    return (
      <Form<TransactionDetailOptionFormType>
        formMethod={methods}
        onSubmit={onSubmit}
        id='transaction_detail_option_form'
      >
        <div className={cx(styles['container'])}>
          {notificationErrorVisible && (
            <div className={cx(styles['inline-error'])}>
              {notificationErrorContextHolder}
            </div>
          )}
          <OptionCode control={control} clearErrors={clearErrors} />
          <OptionLabel control={control} clearErrors={clearErrors} />
          <OptionVisible control={control} />
          <OptionPriority control={control} clearErrors={clearErrors} />
        </div>
      </Form>
    );
  }
);
TransactionDetailOptionForm.displayName = 'TransactionDetailOptionForm';
